/* eslint-disable @typescript-eslint/no-explicit-any */
export const sortArrayAlphabeticallyByField = (items: any[], field: string) => {
  items.sort((a: any, b: any) => {
    if (a[field] < b[field]) {
      return -1;
    }
    if (a[field] > b[field]) {
      return 1;
    }
    return 0;
  });
};
